import { CAST_AI } from '@cast/constants';

import { ClusterStatusFilterGroup } from '../utils/clusterStatusFilterGroup';

export const CLUSTER_STATUS_FILTER_GROUP_LABEL: Record<
  ClusterStatusFilterGroup,
  string
> = {
  cast_ai_managed: `Managed by ${CAST_AI}`,
  kent_managed: `Karpenter managed by ${CAST_AI}`,
  read_only: 'Read only',
};
